<template>
    <section>
        <Breadcrumbs main="Account Settings" title="Account Upgrade" />
        <div class="container-fluid support-ticket-section">
      <div class="row">
        <div class="col-md-12 overlay-bg">
          <px-card :actions="false">
            <div slot="headerCustom">
              <h5>Fund Account</h5>
              <span>Select account funding Type</span>
            </div>
            <div slot="with-padding">
              <div class="row">
                <div class="col-xl-4 col-md-6 box-col-6 wrapper xl-50" v-for="items in cardItems" :key="items.id">
                  <div class="card ecommerce-widget" data-toggle="modal" data-target="#previewAccountDetails" @click="getFundType(items)">
                    <div class="card-body support-ticket-font">
                      <div class="row">
                        <div class="col-7">
                          <h4 class="total-num counter">{{items.title}}</h4>
                          <span style="font-size:13px">{{items.subTitle}}</span>
                        </div>
                        <div class="col-5">
                          <div class="text-md-right icon-wrapper" :class="items.title === 'Card' ? 'bg-1' : items.title === 'Cheque' ? 'bg-2' : items.title === 'Share Details' ? 'bg-3' : 'bg-4' ">
                            <i :class="items.icon" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </px-card>
        </div>
      </div>
    </div>
    <!--modal to preview -->
    <div class="modal fade" id="previewAccountDetails" tabindex="-1" role="dialog" aria-labelledby="accountPreview" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title pl-2" id="accountPreview" style="font-size: 18px">{{title === 'Card' ? 'Fund Account with card' : title === 'Share Details' ? 'Share Details' : title === 'Cheque' ? 'Cheque' : 'USSD'}}</h5>
                <button class="close text-dark" type="button" @click="resetForm" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
                <div class="modal-body p-4">
                    <section v-if="title === 'Card'">
                      <div class="mb-3 row">
                        <div class="col-sm-12 col-md-12">
                          <label class="col-form-label" for="name">Select Account <span class="text-danger">*</span></label>                             
                            <select class="form-control" v-model="form.accountNumber" id="name" name="name" required>
                                <option value="">Select Account</option>
                                <option v-for="account in userAccounts" :key="account.id" :value="account.accountNumber">{{account.accountNumber}} ({{account.accountName}})</option>
                            </select>
                          </div>
                        </div>
                        <div class="mb-3 row">
                            <label class="col-sm-12 col-form-label" for="Description">Amount <span class="text-danger">*</span></label>
                            <div class="col-sm-12 col-xl-12">
                                <input class="form-control" @paste.prevent @keyup="formatNum" @keypress="isNumber" min="0" v-model="form.amount" data-val-number="The field Amount must be a number." data-val-required="The Amount field is required." id="Amount" name="Amount" placeholder="Enter Amount *" required="required" type="text" value="" />
                                <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="Amount" data-valmsg-replace="true"></span>
                            </div>
                        </div>
                        <div class="text-center">
                          <button :disabled="loading" class="proceed-btn mt-3" type="button" @click="proceedToPayment">
                            <div v-if="loading">
                                <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                              </div>
                            <div v-else>Proceed</div>
                          </button>
                        </div>
                    </section>
                    <section v-if="title === 'Share Details'">
                      <div class="share-details">
                        <h5>Bank Name</h5>
                        <p>TAJBank</p>
                        <h5>Account Number</h5>
                        <p>{{userAccounts[0].accountNumber}}</p>
                        <h5>Account Name</h5>
                        <p>{{userAccounts[0].accountName}}</p>
                        <button type="button" class="btn"
                        :class="isCopied ? 'btn-success' : 'btn-primary'"
                          v-clipboard:copy="getUserDetails ? getUserDetails : getUserDetails"
                          v-clipboard:success="onCopy">
                          {{isCopied ? 'Copied!' : 'Copy details'}} <i class="fa fa-copy"></i>
                        </button>
                      </div>
                    </section>
                    <section v-if="title === 'USSD'">
                      <div class="text-left mb-3 d-flex justify-content-between align-items-center" v-for="banks in banksUSSD" :key="banks.id">
                        <div>
                          <img v-if="banks.bankLogo" :src="`https://nigerialogos.com/logos/${banks.bankLogo}/${banks.bankLogo}.png`" class="img-fluid" width="60" :alt="banks.bankLogo">
                          <img v-else :src="bankImage" class="img-fluid" width="50" :alt="banks.bankLogo">
                        </div>
                        <h4 class="bank-text text-dark">{{banks.bankName}}</h4>
                        <span class="text-dark text-left ml-4">{{banks.bankCode}}</span>
                        <span style="cursor:pointer" @click="setCopiedValue(banks.bankCode)" v-clipboard:copy="banks.bankCode"
                          v-clipboard:success="copyCode" class="ml-3 text-left">
                          <i :class="banks.isCopied ? 'text-success' : 'text-danger'" class="fa fa-copy"></i>
                        </span>
                      </div>
                    </section>
                    <section v-if="title === 'Cheque'">
                      <div class="share-details">
                        <h5 class="text-dark">Coming Soon...</h5>
                      </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
    <div :class="showModal === true ? 'overlay-new' : null"></div>
    <div v-if="showModal" class="iframe-modal-body animated fadeIn" style="">
      <div @click="closeModal" class="close" style="cursor:pointer;">&times;</div>
      <iframe :src="flutterwaveLink" height="600" width="500" frameborder="0" title="Payment Iframe"></iframe>
    </div>
    </section>
</template>
<script>
  import $ from 'jquery';
  import { mapState } from 'vuex';
  import { decrypt } from '@/_services/encryption';
  export default {
    data:() => ({
      cardItems:[
        { id: 1, title: 'Card', subTitle: 'Top Up With other bank cards', icon: 'fa fa-credit-card credit-card fa-2x' },
        { id: 2, title: 'Cheque', subTitle: 'Fund account with cheque', icon: 'fa fa-credit-card fa-2x cheque', check: false },
        { id: 3, title: 'Share Details', subTitle: 'Copy or share account details', icon: 'fa fa-paper-plane-o fa-2x' },
        { id: 4, title: 'USSD', subTitle: 'Know our USSD codes', icon: 'fa fa-th-list fa-2x' },
      ],
      banksUSSD:[
        { id: 1, bankName: 'Access (Diamond) Bank ', bankCode: '*901#', isCopied: false, bankLogo: 'access_bank' },
        { id: 2, bankName: 'EcoBank', bankCode: '*326#', isCopied: false, bankLogo: 'ecobank' },
        { id: 3, bankName: 'Fidelity Bank', bankCode: '*770#', isCopied: false, bankLogo: 'fidelity_bank' },
        { id: 4, bankName: 'First Bank', bankCode: '*894#', isCopied: false, bankLogo: 'first_bank' },
        { id: 5, bankName: 'First City Monument Bank (FCMB)', bankCode: '*389*214#', isCopied: false, bankLogo: 'fcmb' },
        { id: 6, bankName: 'Guaranty Trust Bank (GTB) ', bankCode: '*737#', isCopied: false, bankLogo: 'guaranty_trust_bank' },
        { id: 7, bankName: 'Heritage Bank', bankCode: '*322*00#', isCopied: false, bankLogo: 'heritage_bank' },
        { id: 8, bankName: 'JAIZ Bank', bankCode: '*389*301#', isCopied: false, bankLogo: null },
        { id: 9, bankName: 'Keystone Bank ', bankCode: '*7111#', isCopied: false, bankLogo: 'keystone_bank' },
        { id: 10, bankName: 'Polaris Bank ', bankCode: '*833#', isCopied: false, bankLogo: 'polaris_bank' },
        { id: 11, bankName: 'Stanbic IBTC Bank', bankCode: '*909#', isCopied: false, bankLogo: 'stanbic_ibtc' },
        { id: 12, bankName: 'Sterling Bank', bankCode: '*822#', isCopied: false, bankLogo: 'sterling_bank' },
        { id: 13, bankName: 'United Bank for Africa (UBA)', bankCode: '*919#', isCopied: false, bankLogo: 'united_bank_for_africa' },
        { id: 14, bankName: 'Union Bank', bankCode: '*826#', isCopied: false, bankLogo: 'union_bank' },
        { id: 15, bankName: 'Unity Bank', bankCode: '*7799#', isCopied: false, bankLogo: null },
        { id: 16, bankName: 'Wema Bank', bankCode: '*945#', isCopied: false, bankLogo: 'wema_bank' },
        { id: 17, bankName: 'Zenith Bank ', bankCode: '*966#', isCopied: false, bankLogo: 'zenith_bank' },
      ],
      bankImage: require('@/assets/TAJimages/building.png'),
      form: {
        accountNumber: '',
        amount: '0.00',
        transactionReference: '',
        description: 'fund account with card',
        platform: 2,
      },
      title: '',
      loading: false,
      showModal: false,
      flutterwaveLink: '',
      isCopied: false,
      isCopyCode: false,
    }),
    computed: {
      ...mapState({
        // eslint-disable-next-line no-confusing-arrow
        userAccounts: state => state.dashboard.dashboardData ? state.dashboard.dashboardData.accounts : [],
      }),
      getUserDetails() {
        return `Bank Name: TAJBank, Account Number: ${this.userAccounts[0].accountNumber}, Account Name: ${this.userAccounts[0].accountName}`;
      }
    },
    mounted(){
    },
    methods: {
      onCopy() {
        this.isCopied = true;
      },
      copyCode() {
        this.isCopyCode = true;
      },
      setCopiedValue(value){
        this.banksUSSD.map(banks => {
          if(banks.bankCode === value){
            banks.isCopied = true;
          }
        });
      },
      formatNum(event) {
        this.form.amount = event.target.value;
        const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
        this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
      },
      getFundType(val) {
        this.title = val.title;
      },
      resetForm() {
        // reset form input
        this.form.accountNumber = '';
        this.form.amount = '0.00';
      },
      closeModal() {
        this.showModal = false;
      },
      generateUUID() {
        // generate unique id
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (d + Math.random()*16)%16 | 0;
          d = Math.floor(d/16);
          return (c==='x' ? r : (r&0x3|0x8)).toString(16);
        });
        this.form.transactionReference = uuid;
        return uuid;
      },
      proceedToPayment() {
        if (this.form.accountNumber === '' || this.form.amount === '0.00') {
          this.$swal({
            title:'Oops...',
            text: 'Please fill all fields',
            type:'error'
          });
          return;
        } if(this.form.amount < 50){
          this.$swal({
            title:'Oops...',
            text: 'Minimum amount is N50',
            type:'error'
          });
          return;
        } else{
          this.generateUUID();
          this.loading = true;
          const data = {
            accountNumber: this.form.accountNumber,
            amount: Number(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
            transactionReference: this.form.transactionReference,
            platform: this.form.platform,
          };
          this.$store.dispatch('transfers/fundAccountWithCard', data).then((response) => {
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            $('#previewAccountDetails').modal('hide');
            this.flutterwaveLink = userParseData.paymentLink;
            this.showModal = true;
            this.loading = false;
            this.resetForm();
          }).catch((error) => {
            this.loading = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title:'Oops...',
              text: objError.errors[0],
              type:'error'
            });
          });
        }
      },
      isNumber(event) {
        // prevent user to enter non-numeric value
        if (event.keyCode < 48 || event.keyCode > 57) {
          event.returnValue = false;
        }
      },
    }
  };
</script>
<style scoped>
.bank-text {
  font-size: 17px;
  width: 200px;
  text-align: left;
}
.form-control {
  width: 100% !important;
}
.icon-wrapper {
  border-radius: 7px;
  padding: 15px;
  height: 100%;
  width: 60px;
  text-align: right;
  float: right;
}
.wrapper {
  cursor: pointer;
}
.proceed-btn  {
  background-color: #E41613;
  color: #fff;
  border-radius: 10px;
  padding: 10px;
  height: 45px;
  width: 230px;
  font-size: 14px;
  font-weight: bold;
  margin-top: 5px;
  border: none;
}
.ref-btn {
  background-color: #fff;
  color: #E41613;
  border-radius: 10px;
  padding: 10px;
  height: 45px;
  width: 250px;
  font-weight: bold;
  padding: 13px 22px;
  font-size: 14px;
  letter-spacing: 0px;
  margin-top: 5px;
  border: 1px solid #E41613;
}
.modal-dialog-scrollable {
  overflow: hidden;
}
.needs-header {
  font-weight: 400;
}
.bvn-form input {
    width: 100%;
    height: 50px;
    border-radius: 10px;
    border: 1px solid #D9D9D9;
    padding: 0 10px;
    font-size: 16px;
    color: #000;
    margin-bottom: 15px;
}
.bvn-form input::placeholder {
    color: #ACACAC;
    font-size: 14px;
    font-weight: 300;
    text-align: left;
}
.file-upload {
	position: relative;
	display: inline-block;
  width: 100%;
}
 .file-upload__label {
	display: block;
	border: 3px solid #DF351712 !important;
  background-color: #DF351708 !important;
  border-radius: 10px !important;
  width: 100%;
  height: 100px;
  text-align: center;
  padding: 30px 0px;
}
 .file-upload__label:hover {
	cursor: pointer;
}
 .file-upload__input {
	position: relative;
    display: none;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	font-size: 1;
	width: 0;
	height: 100%;
	opacity: 0;
}
.file-upload__label .fa-id-card-o,
.file-upload__label .fa-user-circle-o,
.file-upload__label .icon-file {
    color: #E41613;
    font-size: 25px;
}
.support-ticket-font .total-num {
  font-size: 20px;
  font-weight: 500;
}
.show-text-info {
  color: #E41613;
  margin-right: 207px;
}
.form--input  {
  margin: 10px 0;
}
.credit-card {
  color: #4CD4AB;
  background: #E6F9F1;
}
.cheque {
  color: #FFAF4E;
}
.bg-1 {
  background: #E6F9F1;
}
.bg-2 {
  background: #FFF1E0;
}
.bg-3 {
  color: #E41617;
  background: #FFF4F2;
}
.bg-4 {
  color: #878CFB;
  background: #F2F2FF;
}
/* add overlay */
.overlay-new {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  transition: opacity 500ms;
  z-index: 1000;
}
.share-details {
  text-align: center;
}
.share-details p {
  font-size: 14px;
  font-weight: 500;
  color: #000;
  margin-bottom: 40px;
}
.iframe-modal-body {
  position:absolute; 
  top:10%; 
  left: 25%; 
  z-index: 1000
}
@media (max-width:768px) {
  .iframe-modal-body iframe {
    width:100%;
    height: 500px;
  }
  .iframe-modal-body {
    left: 0% !important;
    padding: 20px;
    right: 0
  }
}
</style>